module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-009"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLI",
      "role": "doc-pagebreak",
      "title": "XLI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLI"
    }
  }, [_vm._v("INTRODUCTION TO JOHN 13–21")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLI"
    }
  }, [_vm._v("The first Bible of the Reformation—Luther’s 1522 German New Testament—singled out the Gospel of John among the “foremost books” of the New Testament as the “one, fine, true, and chief Gospel,” with its focus on the life-giving words of Christ.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-054",
      "id": "ap_ntf-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Although other reformers tended to be less exuberant in elevating John above other books of Scripture, John’s proclamation of eternal life for believers in the Son, read alongside Paul’s teaching of justification by faith, gave John’s Gospel a central place in Reformation preaching, teaching, commentaries, and controversies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-055",
      "id": "ap_ntf-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This volume contains early modern commentary on John 13–21, in which the Evangelist narrates the closing days of Jesus’ ministry with his disciples, his passion, and his resurrection. Like some earlier commentators, the reformers observe that the first twelve chapters of John’s Gospel describes the public ministry of Jesus, which was characterized by miracles or signs pointing to the identity and role of Jesus as the Son of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-056",
      "id": "ap_ntf-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The reformers note a shift in John’s narrative in John 13, when Jesus began interacting in private with his disciples. Jesus washes his disciples’ feet, promises the working of the Holy Spirit, is betrayed by Judas, is tried and crucified and rises again, comes to his troubled disciples, and commissions them to proclaim forgiveness to the world.")]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Uniqueness of John’s Gospel")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Compared with the other three canonical Gospels, the Gospel according to John stands apart with its own perspective and distinctive material, containing much that is not found in Matthew, Mark, and Luke, and omitting much that the other Gospels contain. The second half of John’s Gospel contains a number of such stories and omissions, beginning with the lack of a Last Supper narrative and the inclusion of an account of Jesus’ washing the disciples’ feet. John uniquely relates Jesus’ long conversation with the disciples and his final extended prayer before giving an account of Jesus’ arrest, trial, crucifixion, and resurrection, which intersects with the other Gospels at many points but whose sequence and details sometimes seem at variance with the others.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLII",
      "role": "doc-pagebreak",
      "title": "XLII"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLII"
    }
  }, [_vm._v("Reformation exegetes preaching or commenting on John are chiefly concerned with understanding and expounding John’s Gospel on its own terms, which they understand as being complementary but not contradictory to those of the other Gospels. Yet they also give attention to possibilities for harmonizing the different Gospel accounts. Indeed, some commentators—beginning with Johannes Bugenhagen but including Martin Bucer and Huldrych Zwingli as well—preferred to take up a composite harmony of the texts of the four Gospels for the passion and resurrection narratives in John 18–21 rather than focusing on John’s text on its own.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLII"
    }
  }, [_c('b', [_c('i', [_vm._v("Footwashing. ")])]), _vm._v("In John 13, John’s narrative replaces the story of the institution of the Lord’s Supper with a scene in which Jesus washes the feet of the disciples. Like so much in John’s Gospel, Jesus’ actions and words signify something greater. The reformers saw Jesus’ actions as models for humility and patience that should be imitated.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-057",
      "id": "ap_ntf-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" They also pointed to the internal cleansing of sin that continues throughout a believer’s life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-058",
      "id": "ap_ntf-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Some even saw this as a command from Jesus that the church should institute the washing of feet as an ordinance signifying humility and the continual need for internal cleansing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-059",
      "id": "ap_ntf-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Prayer")]), _vm._v(". ")]), _vm._v("Unlike Matthew and Luke, John’s Gospel does not have an account of the Lord’s Prayer. Instead, the entirety of John 17 contains Jesus’ prayer on the eve of his arrest. Cyril of Alexandria (c. 376–444) in his "), _c('i', [_vm._v("Commentary on John ")]), _vm._v("characterized this passage as Jesus’ high priestly prayer, prayed on behalf of his disciples. This identification was overlooked in Western biblical interpretation until the sixteenth century, when Johannes Brenz, who used Cyril’s exegesis, reintroduced this perspective, which became widespread in early modern and modern interpretations of the passage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-060",
      "id": "ap_ntf-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Reformation exegetes found in Jesus’ prayer an encapsulation of doctrines and themes found elsewhere in John, such as God’s glory, eternal life, the knowledge of God, the Trinity, and election. But the reformers also read Jesus’ prayer as an example teaching Christians how to pray in response to the Word, expressing their dependence on God in words, thoughts, and gestures.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The passion.")])]), _vm._v(" The account of Jesus’ arrest, trial, and crucifixion in John 18–19, while presenting details found nowhere else, also presents challenges of harmonization with the other Gospel accounts. The order and content of Jesus’ hearings before Caiaphas, Annas (found only in John), and Pilate as well as the timing and location of Peter’s denials all receive attention from early modern interpreters. The most fundamental question of chronology, however, involves the relationship of the Passover to the events of Jesus’ passion—whether the day of Passover was the day of the Last Supper (as other Gospels seemed to suggest) or the day of Jesus’ crucifixion (as John asserted). While recognizing the theological significance of John’s presentation of Jesus as the true Passover lamb, exegetes also sought to reconcile these accounts by appealing to the structure of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIII",
      "role": "doc-pagebreak",
      "title": "XLIII"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLIII"
    }
  }, [_vm._v("Jewish dating (in which days began at sundown) as well as to the relationship between the day of Passover and the week of observances that followed it, which might also be called “Passover” in a wider sense. Some commentators, however—including Luther and Calvin—warn readers against becoming too distracted with efforts at harmonization.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLIII"
    }
  }, [_c('b', [_c('i', [_vm._v("Resurrection scenes. ")])]), _vm._v("John 20–21 contains unique stories about the risen Jesus’ appearances to several of his disciples. John gives particular attention to the encounter between the risen Christ and Mary Magdalene. Many reformers acclaim the important role she played as the first to witness the resurrection and as the first to proclaim that good news. For example, Marie le Jars de Gournay observes that the risen Christ revealed himself to Mary Magdalene first, so that she became the “apostle to the apostles”—echoing early patristic interpretations of the text.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-061",
      "id": "ap_ntf-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Others used her story to attack narrow views of ordained ministry by arguing that God consecrated all those who believed and received the Holy Spirit as part of the royal priesthood. Martin Luther held up Mary Magdalene as an exemplar of both faith and love."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-062",
      "id": "ap_ntf-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" However, other commentators—led by Calvin—sought to limit the significance of her role, criticizing her “carnal” attachment to Jesus and arguing that her witness was a unique exception that did not justify an expanded role for women in fulfilling roles typically reserved for ordained men."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-063",
      "id": "ap_ntf-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("John alone, in the last chapter of his Gospel, records that after Jesus’ resurrection the disciples returned to their lives as fishermen, but that Jesus appeared to them on the shore of the Sea of Tiberias. The commentators seek to integrate this appearance with the others recorded in the Gospels or in Paul’s first letter to the Corinthians, pointing out that it fulfills Jesus’ promise to meet the disciples in Galilee. John’s narrative also uniquely describes Peter’s restoration after having denied Christ three times, a signal display of forgiveness and grace. Calvin believed it important that Peter’s honor and authority were restored not only so that he might benefit the ancient church but also as an example to believers in his own day of one becoming “a new man.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-064",
      "id": "ap_ntf-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The reformers remind ministers that their love for their flock demonstrates their love for God and that true ministry flows from that love—while rejecting the idea that Peter, much less his successors, enjoyed any priority in rank over other apostles or ministers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-065",
      "id": "ap_ntf-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Resisting what they saw as the usurpation of power by the papacy, they affirm that Christ alone governs his church.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Reformers and Their Commentaries")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reformers engaged with John’s Gospel in various contexts and genres of exposition. Reformation Bibles included introductions to the books and marginal notes, which sometimes offered interpretation as well as alternate translations. Key passages from John figured in the lectionary "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIV",
      "role": "doc-pagebreak",
      "title": "XLIV"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLIV"
    }
  }, [_vm._v("cycle inherited from the medieval church, from which many Protestants—especially Lutherans and Anglicans—continued to preach, both in oral exposition from the pulpit and in published collections of sermons on the appointed Gospels, called postils.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-066",
      "id": "ap_ntf-066-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" But the reformers also cultivated continuous preaching on John’s Gospel, moving through the text in sequence from sermon to sermon. Beginning with Zwingli in Zurich, this became the preferred model in Reformed circles, though Lutherans set aside days for serial preaching on John as well. Preaching on the passion during Lent and Holy Week also drew from John’s Gospel, either on its own, or in harmonized combination with the other Gospels.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The academic exposition of John’s Gospel—typically in Latin rather than in the vernacular—took place in the classroom but also in published annotations and commentaries. Though the nomenclature used to describe these was not absolutely consistent, the content and focus ranged from close attention to the Greek text and issues of transmission and translation (pioneered by Erasmus’s "), _c('i', [_vm._v("Annotationes")]), _vm._v(" at the beginning of the sixteenth century and continued by Beza’s monumental "), _c('i', [_vm._v("Annotationes Majores")]), _vm._v(" at the century’s end) to discursive commentaries focusing on narrative and theological questions (like the commentaries by Brenz, Calvin, Cruciger, and Alesius, and many others) to theological exposition that organized the material in each chapter of the Gospel by doctrinal topic or "), _c('i', [_vm._v("locus")]), _vm._v(" (a method pioneered in Melanchthon’s theology and elaborated in later works such as the commentary by Hunnius)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-067",
      "id": "ap_ntf-067-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Some exegetes (such as Bucer and Musculus) juxtaposed textual and theological approaches, making two passes through each section of text. By the end of the sixteenth century, enough evangelical commentary had been produced that editors began to assemble comments from Reformation exegetes in a composite commentary, as in Marlorat’s "), _c('i', [_vm._v("Catholic and Evangelical Exposition")]), _vm._v(", a compilation drawing on Melanchthon, Brenz, Calvin, Musculus, and others that anticipates the present enterprise to offer a combined Reformation commentary on Scripture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-068",
      "id": "ap_ntf-068-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Commentaries provided reformers with a means to share their theological and scholarly gifts in service to the wider church. These exegetes had learned rhetoric and languages—Greek and Hebrew in addition to Latin—and had read the ancient teachers of the church. Armed with the best educations of the day and resources previously unavailable, Protestants used commentaries to share their training and knowledge in biblical studies, rhetoric, theology, and patristics in a form appropriate for their followers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-069",
      "id": "ap_ntf-069-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" These commentaries were intended not to supplant or "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLV",
      "role": "doc-pagebreak",
      "title": "XLV"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLV"
    }
  }, [_vm._v("overshadow the Bible but (as Luther put it in his preface to Melanchthon’s commentary on John) to “point to the Scriptures themselves.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-070",
      "id": "ap_ntf-070-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But not all of those who commented on Scripture were scholars or ministers. Among those who advanced the reform movement were numerous women who did so in a variety of roles: as pastor’s wives, rulers and regents, authors of their own letters and treatises, and martyrs. Their considerable contributions have often been overlooked in the story of the Protestant Reformation. In an effort to recognize their contributions more fully, commentary from women such as Argula von Grumbach, Katharina Zell, Mary Astell, and Margaret Fell appear in this volume.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In their approach to interpreting John’s Gospel, Reformation exegetes were united in prioritizing the text and its historical narrative as the foundation for theological exposition. Yet, led by their reading of John’s text itself, the reformers sometimes offered allegorical interpretations as well. For example, when Peter and John ran to the empty tomb—with John arriving first but Peter looking inside—Johannes Brenz interprets them as an allegory of the relationship between faith and love."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-071",
      "id": "ap_ntf-071-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The reformers’ theological exposition of John’s Gospel was of course attentive to and shaped by their own contexts, and not only their confessions and polemical treatises but also their biblical commentaries frequently contain allusions to the religious conflicts of their day—division between the papacy and its opponents, but also growing divergence among theologians and communities within the Reformation movement itself. The opposing parties carried their concerns into their interpretations of key passages in their commentaries.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Major Contributors")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Sixteenth-century Reformation commentators on John can be gathered into four groups according to theological outlook, in addition to Roman Catholic authors. Such a division does not imply, however, that the authors were unaware of or ignored works outside their respective groups. They read those other works and used whatever was beneficial in their own commentaries and attacked (or passed over in pointed silence) whatever was detrimental. The following is a list of the authors most quoted in this work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-072",
      "id": "ap_ntf-072-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Lutheran")]), _vm._v(". ")]), _vm._v("The first Protestant commentary on the Gospel of John was written by Philipp Melanchthon (1497–1560), the Wittenberg scholar who worked closely with Martin Luther and helped lead the movement after Luther’s death. Melanchthon’s work on John was rather short and not as elaborate as his later works, but its influence was great, even outside Lutheran circles. In 1527, Johannes Brenz (1499–1570), the Swabian theologian and pastor, published his own expansive commentary on John, drawing on Melanchthon’s work but exploring his own deep concern with Christology. Caspar Cruciger (1504–1548) was a Wittenberg professor and preacher who followed Melanchthon’s lead on a number of theological topics and helped Luther translate the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVI",
      "role": "doc-pagebreak",
      "title": "XLVI"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVI"
    }
  }, [_vm._v("Bible into German. His commentary on John expanded Melanchthon’s earlier work and was for a long time transmitted under Melanchthon’s own name. The Lutheran superintendent Erasmus Sarcerius (1501–1559) published brief annotations on John emphasizing the application of the text to the faith and life of contemporary Christians. Luther himself (1483–1546), however, did not write a commentary on John, and so his comments gathered here come from his published serial preaching on John and his sermons written for the postils, which nevertheless among them cover almost every part of John’s Gospel.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVI"
    }
  }, [_vm._v("Among later Lutheran expositors, Alexander Alesius (1500–1565) was a Scotsman who traveled back and forth between England and Germany as the English Reformation ebbed and flowed; his commentary on John, making particular use of rhetorical analysis, originated in his lectures as a professor in Leipzig. The Rostock professor David Chytraeus (1530–1600), one of the authors of the Formula of Concord, published his own annotations on John, drawing especially on Augustine among other church fathers in support of Lutheran interpretations. Finally, Aegidius Hunnius (1550–1603), professor at Marburg and Wittenberg, developed Brenz’s christological tradition in a thoroughgoing theological commentary on John’s Gospel.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVI"
    }
  }, [_c('b', [_c('i', [_vm._v("Reformed")]), _vm._v(".")]), _vm._v(" The first Reformed commentary on John was published by Martin Bucer (1491–1551), the irenic Strasbourg theologian, in 1528 and was revised and republished twice in the following decade. The Strasbourg botanist Otto Brunfels published his own brief annotations on John, focusing on theological interpretation and ethical application of the Gospel text. Johannes Oecolampadius (1482–1531), who was a Basel scholar, linguist, and colleague to both Reformed and Lutheran leaders, produced lectures on John that were published after his death in the early 1530s. The Zurich reformer Huldrych Zwingli’s commentary on John was likewise edited posthumously by his friend Leo Jud on the basis of Zwingli’s preaching. Zwingli’s successor in Zurich, Heinrich Bullinger (1505–1575), produced an expansive commentary that is notable not only for its engagement in contemporary polemic but also for its extensive use of patristic commentary. The Bernese theologian Wolfgang Musculus (1497–1563) produced an encyclopedic two-volume commentary on John in the mid-1540s. John Calvin (1509–1564), who led the reform of the church in Geneva, produced a very influential commentary in the early 1550s.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVI"
    }
  }, [_vm._v("After Calvin, his successor Theodore Beza (1519–1605) established a pan-European reputation as a biblical scholar. His "), _c('i', [_vm._v("Annotationes Majores")]), _vm._v(" built on the earlier work of Desiderius Erasmus (1469–1536) and Jacques Lefèvre d’Étaples (ca. 1455–ca. 1536) as well as his own study of New Testament manuscripts, relating theological questions to philological ones. Benedictus Aretius (1505–1574), a Swiss theologian who had studied in Strasbourg, produced an extensive commentary notable for its careful rhetorical and topical outlines of each biblical chapter. The French Reformed pastor and martyr Augustin Marlorat (1506–1562) collated Lutheran and Reformed exegesis (at least in Latin) on the New Testament into a composite commentary.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVI"
    }
  }, [_c('b', [_c('i', [_vm._v("England and Scotland. ")])]), _vm._v("English and Scots commentaries did not rise to prominence until the Stuart dynasty in the early seventeenth century—though earlier Protestant exiles from Great Britain were active on the Continent and many sixteenth-century Continental commentaries "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVII",
      "role": "doc-pagebreak",
      "title": "XLVII"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_vm._v("were translated into English. George Hutcheson (1615–1674) was a Scottish Presbyterian preacher known for his concise commentaries. He wrote his commentary on John in the mid-1650s. "), _c('i', [_vm._v("The English Annotations")]), _vm._v(" was a series of Puritan commentaries, meant to be concise and accessible, that were written in the late 1640 and 1650s by members of the Westminster Assembly. The Anglican strain of the English Reformation is represented by John Trapp (1601–1669), who wrote a five-volume commentary on the Old and New Testaments in the 1660s.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_c('b', [_c('i', [_vm._v("Anabaptist. ")])]), _vm._v("In addition to their common rejection of infant baptism, writers of the Anabaptist group were united in their criticism of the magisterial (e.g., Lutheran and Reformed) reformers for their cooperation with the state and for not going far enough in reforming the church according to Scripture. Subject to persecution throughout Europe, none of the Anabaptists left a systematic commentary on John’s Gospel. Instead, their comments on John are found in various sermons and writings. Some of the most prominent contributors include Balthasar Hubmaier (1480/1485–1528), one of the most educated and prominent theologians in early Anabaptism; Dirk Philips (1504–1568), a leader among Dutch Anabaptism; and Pilgram Marpeck (1495–1556), who was one of the few civil magistrates to become an Anabaptist.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_c('b', [_c('i', [_vm._v("Roman Catholic.")])]), _vm._v(" All of the reformers—Lutheran, Reformed, Anglican, and Anabaptist—drew on the work done by early sixteenth-century Catholic humanist exegetes such as Lefèvre d’Étaples and Desiderius Erasmus, who pioneered the study of the New Testament in Greek. Though neither of these scholars left the Roman church—and though Erasmus eventually opposed Luther’s Reformation—their works came to be regarded with suspicion by many Catholic authorities even as they were used, critically, by Protestants. Among post-Reformation Roman Catholic exegetes whose commentary is excerpted here, Cardinal Tomasso de Vio Cajetan (1469–1534) held the distinction of both having been one of Luther’s earliest opponents and also eventually (like Luther) being condemned himself by the theological faculty of the University of Paris for his exegetical work. Cajetan was notable for his attention to the original biblical text and his willingness to work independently of traditional interpretations. The German Franciscan Johann Wild (1497–1554), whose exegesis drew heavily on the church fathers in order to engage Lutheran interpretations, was nonetheless also put under suspicion (and his works placed on the index) by his coreligionists.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_vm._v("Themes")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_c('b', [_c('i', [_vm._v("Christology and the Lord’s Supper. ")])]), _vm._v("Although the second half of John’s Gospel does not contain the passages that figure most centrally in Reformation discussions of Christology and the closely allied topic of Christ’s presence in the Lord’s Supper—John 1 and John 6—Reformation exegetes nonetheless found in these chapters ample material bearing on these controverted theological questions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVII"
    }
  }, [_vm._v("In particular, the statements that Jesus was about to “depart out of this world to the Father” (Jn 13:1) or was “going to the Father” (Jn 14:28) or “go[ing] away” (Jn 16:7), elicited divergent interpretations, with different implications for Christology and the Eucharist, from Reformed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVIII",
      "role": "doc-pagebreak",
      "title": "XLVIII"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLVIII"
    }
  }, [_vm._v("and Lutheran exegetes. On one hand, Huldrych Zwingli and other Reformed theologians, including John Calvin, understood this to mean that Jesus’ human nature, including his body, had gone into heaven and remained there.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-073",
      "id": "ap_ntf-073-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" If that was the case, then Jesus’ body could not be present in the Eucharist, except as something signified. On the other hand, Martin Luther and other Lutheran theologians, including Johannes Brenz, argued that the language of Jesus’ departure to the Father was primarily a description of his sacrificial death, resurrection, and ascension. The withdrawal of Jesus’ visible presence did not mean the absence of his body, but rather his continual presence with believers everywhere “in his entirety”—including the presence of his body and blood in the Supper."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-074",
      "id": "ap_ntf-074-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One particular passage in these chapters played an important role in the debate between Luther and Zwingli over the Lord’s Supper. Jesus’ statement in John 15 that he is the “true vine” became a test case for understanding the use of figurative and literal language in the Bible."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-075",
      "id": "ap_ntf-075-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Zwingli said that Jesus’ language was figurative: he was symbolically a vine, just as the bread symbolized his body. Luther, on the other hand, argued that the language was literal: Christ does not merely signify but is the true vine—and thus the passage does not support a figurative reading of Jesus’ words “This is my body” at the Last Supper.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Trinity. ")])]), _vm._v("In Jesus’ final moments with his disciples, he spoke about his mission from the Father and promised to send the Spirit as a helper for his disciples. These references opened the door for the reformers to discuss what the text and patristic theologians had to say about the Trinity. Theodore Beza makes use of Tertullian’s "), _c('i', [_vm._v("Against Praxeas")]), _vm._v(" in order to explain the Holy Spirit’s role as an advocate distinct from the Son."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-076",
      "id": "ap_ntf-076-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" John Calvin differentiates the members of the Trinity through their distinct offices and roles."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-077",
      "id": "ap_ntf-077-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Similar discussions appear over Jesus’ statement that he is the true vine and the Father is the gardener or vinedresser (Jn 15:1), explaining how different actions can be ascribed to the different persons of the Trinity even as they work in unity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-078",
      "id": "ap_ntf-078-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some of Jesus’ statements about the Father and the Son required careful explanation to protect readers from falling into what the reformers believed was heresy. For example, Jesus declared that the Father is greater than he (Jn 14:28). According to Nicene trinitarian theology, no subordination exists among the Father, Son, and Holy Spirit—an error made in the fourth century by Arius, who claimed that the Son was subordinate to the Father and was therefore not equally divine. But if there was no hierarchy, how could Jesus say that the Father was greater? Reformers like Heinrich Bullinger and Johannes Brenz make use of patristic sources—particularly Arius’s fourth-century opponent Athanasius—to explain that Jesus’ lower state was not a matter of his divine essence, nature, or person but of his humanity, which he assumed in the incarnation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-079",
      "id": "ap_ntf-079-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIX",
      "role": "doc-pagebreak",
      "title": "XLIX"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_XLIX"
    }
  }, [_c('b', [_c('i', [_vm._v("Knowing Christ")]), _vm._v(". ")]), _vm._v("Closely bound with the trinitarian discussion of texts in Jesus’ farewell discourses was the question of human knowledge of God. For example, in his prayer in John 17, Jesus says that knowing the Father is eternal life itself. Responding to Thomas and Philip in John 14, Jesus comforts the disciples by saying that in knowing and seeing Jesus, they also know the Father. The reformers held that this knowledge of both the Father and the Son consisted in faith—and that if this knowledge itself was eternal life, then works had nothing to contribute to salvation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-080",
      "id": "ap_ntf-080-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Neither reason nor human senses alone could help believers know God. Instead, the knowledge Jesus spoke of comes through the gospel. The reformers explain that through faith in the revealed Word, Christians can know Christ’s divinity, and by knowing the Son one can know the Father since Son and Father are united in nature and in power.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Election and free will. ")])]), _vm._v("Jesus’ discourses with the disciples before his passion provided the reformers with key texts for discussing God’s election and human free will. In Jesus’ final moments with his disciples, he comforted them with the declaration that they had been chosen, or elected, so that they might bear fruit in his name (Jn 15:16). The reformers reflect in these texts not only on Jesus’ choice of the apostles for their ministry but also about election in general. Calvin notes that this election was not based on the elect’s own merit but on God’s grace. He rejects any notion that there might be a causal link between God’s grace and the will of humanity, asserting that we can do nothing, whether in the past or in the future, to earn merit or a place among the elect."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-081",
      "id": "ap_ntf-081-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Philipp Melanchthon argues that this election emboldens Christians to pray and petition the Father through the Son."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-082",
      "id": "ap_ntf-082-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Luther brings out the implications of the doctrine of election for the lives of believers, teaching that the elect should bear public fruit among their neighbors and not only in secret and in private prayers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-083",
      "id": "ap_ntf-083-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One of the central texts arguing for the priority of God’s election over human choice is Jesus’ declaration, “Without me you can do nothing” (Jn 15:5). For Luther and most of his exegetical successors, this was definitive proof of the total incapacity of the human will to take any initiative toward God. Yet Erasmus, in response to Luther, interpreted the passage to mean that, although human beings might not fully accomplish things without Christ’s help, they are nonetheless able to do something, foreshadowing later debates over the human role in salvation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-084",
      "id": "ap_ntf-084-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The discussion of election based on John’s Gospel found a challenging case in the person of Judas, the traitor. He stood among the disciples chosen by Jesus, and yet he would betray Jesus and help to hand him over to the authorities. The reformers explained that Satan’s work through Judas was carried out under God’s supreme power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-085",
      "id": "ap_ntf-085-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Judas’s betrayal was not a lapse in God’s sovereignty but the fulfillment of a role that had been prophesied long before. The reformers also saw in Judas’s story an opportunity to offer pastoral exhortation. If one of the twelve disciples could fall so "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_L",
      "role": "doc-pagebreak",
      "title": "L"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_L"
    }
  }, [_vm._v("infamously, then every believer should avoid complacency lest they, too, fall for Satan’s snares.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-086",
      "id": "ap_ntf-086-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The commentators were also interested in the startling story of Jesus washing Judas’s feet. They disagreed about where Judas was in the order of washing, with some arguing he was first and others last."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-087",
      "id": "ap_ntf-087-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Others saw this act as the ultimate demonstration of Jesus’ patience and role as a servant, even to his betrayer. Some even claimed that Jesus left an opportunity open for Judas to repent.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Pilate and Christ’s kingdom. ")])]), _vm._v("Like Judas, Pontius Pilate plays a key role in the plot of Jesus’ passion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-088",
      "id": "ap_ntf-088-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" But unlike Judas, Pilate receives a nuanced characterization from John: he is a man stuck between the chief priests, who called for Jesus’ execution, and a rabbi from Galilee who was clearly innocent of any crimes Rome would recognize. The reformers’ interpretations of Pilate explore different possibilities left open by John’s narrative, sometimes praising his efforts to avoid Jesus’ execution, and at other times deploring his cowardice and ulterior motives in finally condemning Jesus.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The context of the various commentators may have played a role in their interpretations of Pilate. Most reformers in the Lutheran, Reformed, and Anglican traditions worked closely with local governments to reform the church, creating laws and institutions to support the Reformation. A blanket condemnation of Pilate and his authority might have been understood as a critique of government as a whole. In contrast, the Anabaptist reformers had a much more conflicted relationship with governmental power and were often persecuted by it. It is therefore not surprising that Anabaptist criticism of Pilate often extends to governmental authorities in their own era. Jesus’ words in John 18–19—clearly distinguishing his own kingdom from that of this world yet affirming that Pilate’s authority had been given him “from above”—stood behind Luther’s distinction of the two kingdoms as well as its Anabaptist critique."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-089",
      "id": "ap_ntf-089-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Spirit and the church. ")])]), _vm._v("Jesus made a number of references to the Holy Spirit that required explanation. He called the Spirit “the paraclete” ("), _c('i', [_vm._v("paraklētos")]), _vm._v(" in Greek), and the reformers discussed how best to translate that term. For example, Johannes Oecolampadius, who was a gifted linguist, preferred to translate it as “exhorter” or “inciter.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-090",
      "id": "ap_ntf-090-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Caspar Cruciger and Niels Hemmingsen, however, preferred “advocate,” as in one who serves in a court."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-091",
      "id": "ap_ntf-091-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" For many, the translation of this word was based on their understanding of the Holy Spirit’s function. Heinrich Bullinger believed that the Spirit helps the Christian community bear witness to an unhearing and hateful world by guiding, equipping, and illuminating them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-092",
      "id": "ap_ntf-092-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Others saw the Spirit working in the church and the daily lives of individual believers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_LI",
      "role": "doc-pagebreak",
      "title": "LI"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_LI"
    }
  }, [_vm._v("Jesus’ statement that the Spirit would “convict” the world also produced a variety of interpretations. Theodore Beza saw this as a reference to the apostles’ own day, when the Spirit came on them at Pentecost (Acts 2) and the people had their consciences piqued by Peter’s sermon and confessed their error.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-093",
      "id": "ap_ntf-093-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Martin Luther, however, saw this as a description of the way the Spirit would convict individuals of their sins in order to bring them to inward righteousness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-094",
      "id": "ap_ntf-094-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Catholics like Johann Eck believed Jesus’ statement was best understood as the Spirit guiding the church through the ages even as it enlightened and governed the church’s development through the inspired apostles and holy fathers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-095",
      "id": "ap_ntf-095-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Yet Protestant exegetes refused to drive a wedge between the work of the Spirit and the apostolic words of Scripture: for them, as John said in the colophon to his Gospel, it was those things that had been written, inspired by the Spirit, that were efficacious and sufficient to produce faith and give eternal life in Jesus’ name.")])]), _c('p', {
    staticClass: "sep"
  }, [_vm._v("*"), _c('br'), _vm._v("*     *")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Throughout the centuries, and in particular again in the age of Reformation, the Gospel of John has offered its readers a unique vision of the eternal Word of God made flesh in the person of Jesus Christ for the salvation of the world. John Calvin expresses well the benefit that people still today might gain in reading the words of John, the Beloved Disciple and the Evangelist:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Yet we ought to remember . . . that the summary which the Evangelists have committed to writing is sufficient both for regulating faith and for obtaining salvation. Anyone who has duly profited under such teachers will be truly wise. And, indeed, since they were appointed by God . . . so it is our duty to depend wholly on their testimony, and to desire nothing more than what they have handed down to us; and especially, because their pens were guided by the sure providence of God, that they might . . . make known to us all that God knew to be necessary for us, who alone is wise, and the only fountain of wisdom; to whom be praise and glory forever. Amen."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntf-096",
      "id": "ap_ntf-096-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 84
// module chunks = 0